import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getNextCycleDate),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(isDateInNextCycle),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(determineScheduleContext);

import * as logger from 'universal-logger';
import { DALNotFoundError } from '@classpass/dal';
import isBefore from 'date-fns/isBefore';
import parseISO from 'date-fns/parseISO';
import { call, put } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import SCHEDULE_CONTEXT from 'constants/schedule-context';
import { deepExtract } from 'helpers/deep';
import { setScheduleContext } from 'redux/modules/user';
import { userCreditBalance, userSubscription } from 'redux/saga/entities/bound';
import { scheduleContext } from 'redux/saga/selectors';
import { getUserId } from '../helpers';
export var selectUserCredits = function selectUserCredits(state) {
  return userCreditBalance.data(state, scheduleContext(state)) || {
    credits_total: 0,
    credits_remaining: 0
  };
};
export function getNextCycleDate(client, userId) {
  var subscriptionData;
  return regeneratorRuntime.wrap(function getNextCycleDate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(fetchEntityIfNeeded, userSubscription, [client, userId]);

        case 3:
          subscriptionData = _context.sent;
          _context.next = 12;
          break;

        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);

          if (!(_context.t0 instanceof DALNotFoundError)) {
            _context.next = 10;
            break;
          }

          return _context.abrupt("return");

        case 10:
          _context.next = 12;
          return call(logger.error, 'Could not load subscription for user', _context.t0);

        case 12:
          return _context.abrupt("return", deepExtract('next_cycle_subscription.cycle_start_date', subscriptionData, null));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 6]]);
}
export function isDateInNextCycle(client, userId, date) {
  var nextSubscriptionCycleDate;
  return regeneratorRuntime.wrap(function isDateInNextCycle$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(getNextCycleDate, client, userId);

        case 2:
          nextSubscriptionCycleDate = _context2.sent;

          if (nextSubscriptionCycleDate && date) {
            _context2.next = 5;
            break;
          }

          return _context2.abrupt("return", false);

        case 5:
          return _context2.abrupt("return", !isBefore(parseISO(date), parseISO(nextSubscriptionCycleDate)));

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function determineScheduleContext(client, scheduleDate) {
  var userId, isNextCycle;
  return regeneratorRuntime.wrap(function determineScheduleContext$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(getUserId, client);

        case 2:
          userId = _context3.sent;

          if (userId) {
            _context3.next = 5;
            break;
          }

          return _context3.abrupt("return");

        case 5:
          _context3.next = 7;
          return call(isDateInNextCycle, client, userId, scheduleDate);

        case 7:
          isNextCycle = _context3.sent;
          _context3.next = 10;
          return put(setScheduleContext(isNextCycle ? SCHEDULE_CONTEXT.NEXT_CYCLE : SCHEDULE_CONTEXT.CURRENT_CYCLE));

        case 10:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}